import React from "react";
import nailInfillImg from "./../../../Images/NailSalonInnerPages/Nails Extension Infill.png";

const NailInfillImg = () => {
  return (
    <div className="nailExtImg">
      <img src={nailInfillImg} alt="nailInfillImg" />
    </div>
  );
};

export default NailInfillImg;
